// extracted by mini-css-extract-plugin
export var container = "Implementations-module--container--uT9OD";
export var singleImplementationContainer = "Implementations-module--singleImplementationContainer--+hgt-";
export var flag = "Implementations-module--flag--WVisF";
export var flagText = "Implementations-module--flagText--EPKBw";